import React from 'react';
import classNames from 'classnames';
import { ProductTileProps, TagType } from "../../../ProductTile/types";
import MetaText from "../../../../ui/Typography/texts/MetaText";
import styles from './ProductSwatches.module.scss';
const SWATCHES_LIMIT = 4;
const remainingSwatches = (nub) => (nub > SWATCHES_LIMIT ? nub - SWATCHES_LIMIT : 0);
const ProductSwatches = ({ swatches, swatchesClassName, swatchesTotal, swatchesHighlightOnHover, colorSwatchSpacingTop, colorSwatchSpacingBottom, shouldShowRemainNumberAsLink, linkClickCallback, }) => {
    if (!swatchesTotal)
        return null;
    const renderRemainingComponent = () => {
        var _a, _b;
        if (swatchesTotal <= SWATCHES_LIMIT)
            return null;
        const remainingProps = {
            className: styles.remainingSwatches,
            'aria-hidden': !shouldShowRemainNumberAsLink ? 'true' : undefined,
            Tag: (shouldShowRemainNumberAsLink ? 'a' : 'span'),
            href: shouldShowRemainNumberAsLink ? (_a = swatches === null || swatches === void 0 ? void 0 : swatches[SWATCHES_LIMIT]) === null || _a === void 0 ? void 0 : _a.colorLink : undefined,
            title: shouldShowRemainNumberAsLink ? (_b = swatches === null || swatches === void 0 ? void 0 : swatches[SWATCHES_LIMIT]) === null || _b === void 0 ? void 0 : _b.colorName : undefined,
            onClick: shouldShowRemainNumberAsLink
                ? linkClickCallback
                : undefined,
        };
        return React.createElement(MetaText, Object.assign({}, remainingProps), `+ ${remainingSwatches(swatchesTotal)}`);
    };
    return (React.createElement("div", { className: classNames(swatchesClassName, styles.swatchesContainer, colorSwatchSpacingTop && styles[`${colorSwatchSpacingTop}-top`], colorSwatchSpacingBottom && styles[`${colorSwatchSpacingBottom}-bottom`]) },
        React.createElement("ul", { className: styles.swatchesList }, swatches &&
            swatches.slice(0, SWATCHES_LIMIT).map((swatch) => (React.createElement("li", { className: styles.item, key: swatch.hexColor || swatch.imageSrc },
                React.createElement("a", { href: swatch.colorLink, className: classNames(styles.swatch, swatchesHighlightOnHover ? styles.swatchHighlight : undefined, !swatch.isSquare ? styles.swatchRound : undefined), style: !swatch.imageSrc ? { backgroundColor: swatch.hexColor } : undefined, title: swatch.colorName, onClick: linkClickCallback },
                    swatch.imageSrc && (React.createElement("img", { src: swatch.imageSrc, alt: swatch.colorName, className: styles.swatchImage })),
                    swatch.colorName))))),
        renderRemainingComponent()));
};
export default ProductSwatches;
//# sourceMappingURL=ProductSwatches.js.map